/**
 * T.C. Kimlik Numarasi dogrulamasi.
 * Kural: 11 hane, ilk hane 0 olamaz,
 *   d10 = ((d1+d3+d5+d7+d9)*7 - (d2+d4+d6+d8)) mod 10
 *   d11 = (d1..d10 toplami) mod 10
 */
export function tcknGecerliMi(deger: string | null | undefined): boolean {
  if (!deger) return false;
  const s = deger.trim();
  if (!/^[1-9][0-9]{10}$/.test(s)) return false;

  const d = [...s].map(Number) as number[];
  const tekler = d[0]! + d[2]! + d[4]! + d[6]! + d[8]!;
  const ciftler = d[1]! + d[3]! + d[5]! + d[7]!;

  const hane10 = (tekler * 7 - ciftler) % 10;
  if (((hane10 + 10) % 10) !== d[9]!) return false;

  const ilkOn = d.slice(0, 10).reduce((a, b) => a + b, 0);
  return ilkOn % 10 === d[10]!;
}

/** Gorselden gelen TCKN'yi temizler (bosluk, nokta, harf ayikla). */
export function tcknNormalize(deger: string | null | undefined): string | null {
  if (!deger) return null;
  const sadeceRakam = deger.replace(/\D/g, '');
  return sadeceRakam.length === 11 ? sadeceRakam : null;
}
